
import React, { useRef, useEffect, useState } from 'react'
import '../styleCss/a.css'

import { HashLink } from 'react-router-hash-link';
import TypingText from './TypingText';

import backImage from "../../assets/categouresbg.png";


import RSImg from "../../assets/RSI.png";
import SMAImg from "../../assets/SMA.png";
import EMA1 from "../../assets/EMA.png";
import BImg from "../../assets/BB.jpg";
import SOImg from "../../assets/SO1.jpg";
import VWPAImg from "../../assets/VWAP.png";
import OBVImg from "../../assets/OSI.png";
import FIImg from "../../assets/FI.jpg";
import ADXImg from "../../assets/ADX1.jpg";
import MAcdImg from "../../assets/MACD.png";
import ATRImg from "../../assets/ATR.jpg";
import PivotPoint from "../../assets/PivitPoint.png";
import { Link } from "react-router-dom";
import SEO from '../SEO';
import Header from './Header';
import Footer from './Footer';

  // <Route path="/simple-moving-average-indicator-algocontroller" element={<Sma />} />
  //     <Route path="/Eexponential-moving-average-indicator-algocontroller" element={<Ema />} />
  //     <Route path="/volume-weighted-average-price-indicator-algocontroller" element={<Vwap />} />
  //     <Route path="/stochastic-oscillator-indicator-algocontroller" element={<StochasticOscillator />} />
  //     <Route path="/relative-strength-index-indicator-algocontroller" element={<Rsi />} />
  //     <Route path="/on-balance-volume-indicator-algocontroller" element={<Obv />} />
  //     <Route path="/fibonacci-retracement-indicator-algocontroller" element={<FibonacciRetracement />} />
  //     <Route path="/average-directional-index-indicator-algocontroller" element={<Adx />} />
  //     <Route path="/moving-average-convergence-divergence-indicator-algocontroller" element={<Macd />} />
  //     <Route path="/bollinger-bands-indicator-algocontroller" element={<Bollingerbrands />} />
  //     <Route path="/average-true-range-indicator-algocontroller" element={<ATR />} />
  //     <Route path="/pivot-point-indicator-algocontroller" element={<PivotPoint />} />


const categories = [
  {
    title: "Simple Moving Average (SMA)",
    anchor: "/simple-moving-average-indicator-algocontroller"
  },
  {
    title: "Exponential Moving Average (EMA)",
    anchor: "/exponential-moving-average-indicator-algocontroller"
  },
  {
    title: "Relative Strength Index (RSI)",
    anchor: "/relative-strength-index-indicator-algocontroller"
  },
  {
    title: "Bollinger Bands",
    anchor: "/bollinger-bands-indicator-algocontroller"
  },
  {
    title: "Moving Average Convergence Divergence (MACD)",
    anchor: "/moving-average-convergence-divergence-indicator-algocontroller"
  },
  {
    title: "Stochastic Oscillator",
    anchor: "/stochastic-oscillator-indicator-algocontroller"
  },
  {
    title: "Fibonacci Retracement",
    anchor: "/fibonacci-retracement-indicator-algocontroller"
  },
  {
    title: "Volume Weighted Average Price (VWAP)",
    anchor: "/volume-weighted-average-price-indicator-algocontroller"
  },
  {
    title: "Average Directional Index (ADX)",
    anchor: "/average-directional-index-indicator-algocontroller"
  },
  {
    title: "On-Balance Volume (OBV)",
    anchor: "/on-balance-volume-indicator-algocontroller"
  },

  {
    title: "Average True Range(ATR)",
    anchor: "/average-true-range-indicator-algocontroller"
  },

  {
    title: "Pivot Point",
    anchor: "/pivot-point-indicator-algocontroller"
  }
];



const cardsData = [
  {
    id: 1,
    image: SMAImg,
    title: "Simple Moving Average (SMA)",
    // date: "July 24, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "SMA calculates the average price of a security over a specific number of periods. It smooths out price data to identify the overall trend direction.    ",
    link: "/simple-moving-average-indicator-algocontroller",
  },
  {
    id: 2,
    image: EMA1,
    title: "Exponential Moving Average (EMA)",
    date: "August 10, 2025",
    author: "example@gmail.com",
    description:
      "EMA gives more weight to recent prices, making it more responsive to new information. It helps traders spot trend changes faster than SMA.",
    link: "/exponential-moving-average-indicator-algocontroller",
  },
  {
    id: 3,
    image: RSImg,
    title: "Relative Strength Index (RSI)",
    // date: "September 3, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "RSI is a momentum oscillator that measures the speed and change of price movements, indicating overbought or oversold conditions (0–100 scale).",
    link: "/relative-strength-index-indicator-algocontroller",
  },
  {
    id: 4,
    image: BImg,
    title: "Bollinger Bands",
    // date: "September 10, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "Bollinger Bands consist of a moving average with upper and lower bands based on standard deviation, showing price volatility and potential reversals.",
    link: "/bollinger-bands-indicator-algocontroller",
  },
  {
    id: 5,
    image: MAcdImg,
    title: "Moving Average Convergence Divergence (MACD)",
    // date: "September 15, 2024",
    author: "bhavishygoyal@gmail.com",
    description:
      "MACD shows the relationship between two moving averages of prices. It helps traders identify momentum, trend direction, and potential buy/sell signals.",
    link: "/moving-average-convergence-divergence-indicator-algocontroller",
  },
  {
    id: 6,
    image: SOImg,
    title: "Stochastic Oscillator",
    // date: "September 18, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "The Stochastic Oscillator compares a security's closing price to its price range over a set period, identifying overbought or oversold conditions.",
    link: "/stochastic-oscillator-indicator-algocontroller",
  },
  {
    id: 7,
    image: FIImg,
    title: "Fibonacci Retracement",
    date: "September 20, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "Fibonacci retracement levels indicate potential support and resistance areas based on the key Fibonacci ratios of a price move.",
    link: "/fibonacci-retracement-indicator-algocontroller",
  },
  {
    id: 8,
    image: VWPAImg,
    title: "Volume Weighted Average Price (VWAP)",
    // date: "September 22, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "VWAP shows the average price a security has traded at throughout the day, based on both volume and price, used to assess fair value.",
    link: "/volume-weighted-average-price-indicator-algocontroller",
  },
  {
    id: 9,
    image: ADXImg,
    title: "Average Directional Index (ADX)",
    // date: "September 24, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "ADX measures the strength of a trend, regardless of its direction, helping traders know when the market is trending or ranging.",
    link: "/average-directional-index-indicator-algocontroller",
  },
  {
    id: 10,
    image: OBVImg,
    title: "On-Balance Volume (OBV)",
    // date: "September 26, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "OBV uses volume flow to predict price movement, showing if volume is supporting or contradicting price trends.",
    link:  "/on-balance-volume-indicator-algocontroller",
  },

  {
    id: 11,
    image: ATRImg,
    title: "Average True Range (ATR)",
    // date: "September 26, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "ATR measures market volatility by calculating the average range of price movements over a specific period, helping traders assess risk and set stop-loss levels.",
    link:"/average-true-range-indicator-algocontroller",
  },
  {
    id: 12,
    image: PivotPoint,
    title: "Pivot Point",
    // date: "September 26, 2024",
    // author: "bhavishygoyal@gmail.com",
    description:
      "Pivot Points are key price levels calculated from the previous period's high, low, and close, used to identify potential support and resistance levels for intraday trading.",
    link: "/pivot-point-indicator-algocontroller",
  },
];



const Education = () => {



  const [shuffled, setShuffled] = useState([]);

  useEffect(() => {
    const shuffledCopy = [...cardsData]
      .sort(() => Math.random() - 0.5) // shuffle
      .slice(0, 12);                    // only 7 items

    setShuffled(shuffledCopy);
  }, []); // run only once on mount


  // const [categoriesSufffel, setCategories] = useState([])
  // useEffect(() => {



  //   const catsuf = [...categories]
  //     .sort(() => Math.random() - 0.5)
  //     .slice(0, 7)
  //   setCategories(catsuf)

  // }, [])


  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 3;

  // if number of rows greater than rows than  we page number added
  const totalPages = Math.ceil(cardsData.length / rowsPerPage);

  // Get current page data
  const startIdx = (currentPage - 1) * rowsPerPage;
  const currentRows = shuffled.slice(startIdx, startIdx + rowsPerPage);



  return (


    <div className='w-screen h-full'>


      <Header></Header>

      <div className='flex w-full  justify-center items-center flex-wrap '>

        {/* // <div className="space-y-10 "> */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-8"> */}
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-6 md:gap-8 m-3  ">


          {currentRows.map((card, index) => (
            <div
              key={card.id}
              className={`flex flex-col  md:flex-row  justify-start items-center  px-0 bg-white backdrop:blur-sm
 rounded-2xl shadow-md hover:shadow-2xl overflow-hidden transition border border-gray-300 w-full max-w-[1000px] lg:w-[1000px] lg:h-[400px]
            ${index % 2 !== 0 ? "md:flex-row-reverse" : ""}`}
            >

              <div className="md:w-1/2 w-full  relative flex flex-col rounded-lg h-full">

                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover shadow-lg  border-white "

                />
              </div>

              {/* Content */}
              {/* <div className="md:w-1/2 w-full p-4 h-full flex flex-col justify-center shadow-2xl bg-white/30"> */}
              {/* <div className="md:w-1/2 w-full p-2 md:p-4 h-auto flex flex-col justify-center shadow-2xl bg-white/30"> */}
              <div className="w-full md:w-1/2 p-4 flex flex-col justify-center bg-white/20 h-full backdrop-blur-lg">
                <span className="uppercase text-xs font-semibold text-white bg-blue-600 px-3 py-1 rounded-full self-start mb-8 md:mb-8">
                  Technical Indicators
                </span>

                <div className="mb-4 md:mb-12">
                  <h1 className="text-xl sm:text-xl md:text-3xl font-bold text-gray-900">
                    {card.title}
                  </h1>
                  <div className="border-t border-black/60 my-3"></div>
                  <p className="text-base md:text-lg font-semibold text-gray-800 leading-relaxed">
                    {card.description}
                  </p>
                </div>

                <a
                  href={card.link}
                  className="mt-4 inline-block text-blue-500 hover:underline text-sm md:text-md font-medium hover:text-blue-700"
                >
                  Read More →
                </a>
              </div>

            </div>

          ))}


        </div>

        <div className=' grid grid-cols-1 sm:grid-cols-2  md:grid-col-2 xl:grid-cols-1 lg:grid-cols-2 gap-4 p-4 mt-2 max-w-7xl '>



          <div className="  bg-white/30  w-xs md:max-w-md lg:max-w- shadow-md rounded-xl border  border-gray-200 min-h-[400px] h-auto ">
            <div className="p-4">
              {/* <h2 className="text-2xl underline underline-offset-1 font-semibold text-gray-800 mb-4 flex items-center gap-2">
              Promo Video
              <span className="flex-1 h-px bg-gray-200"></span>
            </h2> */}

              {/* Video Section */}
              <div className="flex  w-full items-center h-[550px]">
                <iframe
                  src="https://www.youtube.com/embed/N72f3HKqsh8?autoplay=1&loop=1&mute=1&playlist=N72f3HKqsh8"
                  // <- put your video file path here

                  title='Algo Youtuble Video'

                  allow="autoplay; encrypted-media"
                  allowFullScreen

                  className="rounded-lg shadow-md w-full h-full object-cover"
                />
              </div>
            </div>
          </div>



          <div className="relative w-full w-xs md:max-w-sm lg:max-w-md 
                mt-3 min-h-[300px] h-auto 
                rounded-2xl shadow-xl border border-white/20 
                bg-gradient-to-b from-cyan-100/30 to-white/30 
                backdrop-blur-md overflow-hidden"
            // style={{ backgroundImage: `url(${backImage})` }}

          >

            {/* Background decorative image (optional, like your screenshot) */}


            {/* Card content */}
            <div className="relative p-5">
              <h2 className="text-2xl font-semibold text-cyan-900 mb-4 flex items-center gap-2">
                Categories
              </h2>

              <div className="flex flex-col gap-2 p-4 text-xl">
                {categories.map((cat) => (
                  <a
                    key={cat.anchor}
                    href={cat.anchor}
                    className="text-cyan-900 no-underline relative pl-4 hover:underline hover:text-blue-600 before:content-['•'] before:absolute before:left-0 before:text-blue-500"
                  >
                    {cat.title}
                  </a>
                ))}
              </div>
            </div>
          </div>


        </div>
      </div>
      <div className="  flex justify-center gap-2 flex-wrap m-2">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm sm:text-base rounded ${currentPage === index + 1
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-black"
              }`}
          >
            Page {index + 1}
          </button>
        ))}
      </div>

      <Footer></Footer>
    </div>
  );
};

export default Education;
